import { useDesignBoardPageState } from '~/modules/design-board/component/context';
import { MobilePinMenu } from '~/modules/design-board/component/mobile-menu/MobilePinMenu';
import { MobileBoardMenu } from '~/modules/design-board/component/mobile-menu/MobileBoardMenu';
import { MobilePermissionMenu } from '~/modules/design-board/component/mobile-menu/MobilePermissionMenu';

export const MobileBottomMenuContent = () => {
    const { state } = useDesignBoardPageState();

    if (state.bottomMenuData?.type === 'board') {
        return <MobileBoardMenu />;
    }

    if (state.bottomMenuData?.type === 'pin') {
        return <MobilePinMenu />;
    }

    if (state.bottomMenuData?.type === 'permission') {
        return <MobilePermissionMenu />;
    }

    return null;
};
